import groq from 'groq'
import { DesignQuery } from '../atoms/DesignQuery'
import { MediaObjectQuery } from '../molecules/MediaObjectQuery'
import { imageObject } from '../atoms/imageObject'
import { videoObject } from '../atoms/videoObject'
import { vimeoObject } from '../atoms/vimeoObject'
export const heroQuery = groq`
_type == "Hero" => {
  title, 
  _type,
  description,
  medias[]{
        media {
      select,
      ...,
      ${imageObject},
      ${videoObject},
      ${vimeoObject}
    }
  },
  ${DesignQuery},
}
`
